const LUPZ_POPUP_PANEL_SELECTOR = '.lupz-series-popup-panel, .lupz-popup-panel';
const LUPZ_POPUP_MAIN_IMAGE_SELECTOR = '.lupz-popup-preview-img, .lupz-main-popup-img';
const LUPZ_MOBILE_MQ = window.matchMedia('(max-width: 768px)');

const getPanelImages = (panel) => {
  const images = [];

  for (const button of panel.querySelectorAll('.lupz-popup-thumbs button[data-full]')) {
    const fullImage = button.getAttribute('data-full');

    if (!fullImage) {
      continue;
    }

    images.push({
      full: fullImage,
      alt: button.querySelector('img')?.alt || '',
    });
  }

  return images;
};

const setPopupMainImage = (mainImage, fullImage) => {
  if (!mainImage || !fullImage) {
    return;
  }

  mainImage.src = fullImage;
  mainImage.srcset = `${fullImage} 1600w`;
  mainImage.sizes = '(min-width: 1100px) 50vw, 100vw';
};

const getActiveSlideIndex = (track) => {
  if (!track || track.clientWidth <= 0) {
    return 0;
  }

  return Math.round(track.scrollLeft / track.clientWidth);
};

const syncDots = (track, dots) => {
  const activeIndex = getActiveSlideIndex(track);

  for (const [index, dot] of dots.entries()) {
    dot.classList.toggle('is-active', index === activeIndex);
    dot.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
  }
};

const scrollToSlide = (track, index) => {
  track.scrollTo({
    left: track.clientWidth * index,
    behavior: 'smooth',
  });
};

const resetMobileGallery = (panel) => {
  const track = panel.querySelector('.lupz-popup-mobile-gallery__track');

  if (!track) {
    return;
  }

  track.scrollLeft = 0;

  const dots = panel.querySelectorAll('.lupz-popup-mobile-gallery__dot');
  syncDots(track, dots);
};

const buildMobileGallery = (panel) => {
  const mainImageContainer = panel.querySelector('.lupz-popup-main-image');

  if (!mainImageContainer) {
    return;
  }

  const existingGallery = mainImageContainer.querySelector('[data-lupz-popup-gallery]');

  if (existingGallery) {
    return;
  }

  const images = getPanelImages(panel);

  if (images.length <= 1) {
    return;
  }

  const gallery = document.createElement('div');
  gallery.className = 'lupz-popup-mobile-gallery';
  gallery.setAttribute('data-lupz-popup-gallery', '');

  const track = document.createElement('div');
  track.className = 'lupz-popup-mobile-gallery__track';
  track.setAttribute('role', 'region');
  track.setAttribute('aria-label', 'Product photos');

  for (const image of images) {
    const slide = document.createElement('div');
    slide.className = 'lupz-popup-mobile-gallery__slide';

    const slideImage = document.createElement('img');
    slideImage.src = image.full;
    slideImage.srcset = `${image.full} 1600w`;
    slideImage.sizes = '100vw';
    slideImage.alt = image.alt;
    slideImage.loading = 'eager';
    slideImage.decoding = 'async';

    slide.appendChild(slideImage);
    track.appendChild(slide);
  }

  const dots = document.createElement('div');
  dots.className = 'lupz-popup-mobile-gallery__dots';
  dots.setAttribute('role', 'tablist');
  dots.setAttribute('aria-label', 'Choose product photo');

  const dotButtons = images.map((image, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'lupz-popup-mobile-gallery__dot';
    dot.setAttribute('role', 'tab');
    dot.setAttribute('aria-label', `Photo ${index + 1} of ${images.length}`);
    dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

    if (index === 0) {
      dot.classList.add('is-active');
    }

    dot.addEventListener('click', () => {
      scrollToSlide(track, index);
    });

    dots.appendChild(dot);
    return dot;
  });

  track.addEventListener(
    'scroll',
    () => {
      syncDots(track, dotButtons);
    },
    { passive: true }
  );

  gallery.appendChild(track);
  gallery.appendChild(dots);
  mainImageContainer.appendChild(gallery);
  mainImageContainer.classList.add('lupz-popup-main-image--has-mobile-gallery');
};

const initPanel = (panel) => {
  if (panel.querySelector('.lupz-popup-mobile-gallery-host')) {
    return;
  }

  buildMobileGallery(panel);
};

const initAllPanels = () => {
  for (const panel of document.querySelectorAll(LUPZ_POPUP_PANEL_SELECTOR)) {
    initPanel(panel);
  }
};

const observePanelOpen = (panel) => {
  const observer = new MutationObserver(() => {
    if (panel.classList.contains('is-open')) {
      resetMobileGallery(panel);
    }
  });

  observer.observe(panel, {
    attributes: true,
    attributeFilter: ['class'],
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initAllPanels();

  for (const panel of document.querySelectorAll(LUPZ_POPUP_PANEL_SELECTOR)) {
    observePanelOpen(panel);
  }
});

LUPZ_MOBILE_MQ.addEventListener('change', initAllPanels);
